export default __webpack_public_path__ + "static/media/eyeClose.c8f0d0ee.svg";